"use strict";
var _a, _b, _c, _d, _e, _f, _g;
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationLog = exports.NotificationTemplate = exports.NotificationStatus = exports.NotificationChannel = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const customer_entity_1 = require("../customers/customer.entity");
const user_entity_1 = require("../users/user.entity");
var NotificationChannel;
(function (NotificationChannel) {
    NotificationChannel["WHATSAPP"] = "whatsapp";
    NotificationChannel["EMAIL"] = "email";
    NotificationChannel["SMS"] = "sms";
})(NotificationChannel || (exports.NotificationChannel = NotificationChannel = {}));
var NotificationStatus;
(function (NotificationStatus) {
    NotificationStatus["QUEUED"] = "queued";
    NotificationStatus["SENT"] = "sent";
    NotificationStatus["FAILED"] = "failed";
    NotificationStatus["DELIVERED"] = "delivered";
    NotificationStatus["OPTED_OUT"] = "opted_out";
})(NotificationStatus || (exports.NotificationStatus = NotificationStatus = {}));
var NotificationTemplate;
(function (NotificationTemplate) {
    // Order lifecycle
    NotificationTemplate["ORDER_WORKING"] = "order_working";
    NotificationTemplate["ORDER_DISPATCHED"] = "order_dispatched";
    NotificationTemplate["ORDER_DELIVERED"] = "order_delivered";
    // Feedback
    NotificationTemplate["FEEDBACK_FORM"] = "feedback_form";
    NotificationTemplate["FEEDBACK_FOLLOWUP"] = "feedback_followup";
    NotificationTemplate["VIDEO_REVIEW_REQUEST"] = "video_review_request";
    // Payments
    NotificationTemplate["PAYMENT_DETAILS"] = "payment_details";
    // Medical
    NotificationTemplate["DOC_UPLOAD_REQUEST"] = "doc_upload_request";
    // Appointments
    NotificationTemplate["APPOINTMENT_CONFIRMED"] = "appointment_confirmed";
    // Marketing / misc
    NotificationTemplate["WEBSITE_LINK"] = "website_link";
    // Tickets / evidence
    NotificationTemplate["EVIDENCE_LINK_SENT"] = "evidence_link_sent";
})(NotificationTemplate || (exports.NotificationTemplate = NotificationTemplate = {}));
let NotificationLog = class NotificationLog {
};
exports.NotificationLog = NotificationLog;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], NotificationLog.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => customer_entity_1.Customer, { nullable: true, onDelete: 'SET NULL' }),
    tslib_1.__metadata("design:type", typeof (_a = typeof customer_entity_1.Customer !== "undefined" && customer_entity_1.Customer) === "function" ? _a : Object)
], NotificationLog.prototype, "customer", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => user_entity_1.User, { nullable: true, onDelete: 'SET NULL' }),
    tslib_1.__metadata("design:type", typeof (_b = typeof user_entity_1.User !== "undefined" && user_entity_1.User) === "function" ? _b : Object)
], NotificationLog.prototype, "sentBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ length: 20, nullable: true }),
    tslib_1.__metadata("design:type", String)
], NotificationLog.prototype, "toPhone", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ length: 150, nullable: true }),
    tslib_1.__metadata("design:type", String)
], NotificationLog.prototype, "toEmail", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'enum', enum: NotificationChannel }),
    tslib_1.__metadata("design:type", String)
], NotificationLog.prototype, "channel", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'enum', enum: NotificationTemplate, nullable: true }),
    tslib_1.__metadata("design:type", String)
], NotificationLog.prototype, "template", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'text' }),
    tslib_1.__metadata("design:type", String)
], NotificationLog.prototype, "messageBody", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'enum', enum: NotificationStatus, default: NotificationStatus.QUEUED }),
    tslib_1.__metadata("design:type", String)
], NotificationLog.prototype, "status", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    tslib_1.__metadata("design:type", Number)
], NotificationLog.prototype, "relatedEntityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ length: 60, nullable: true }),
    tslib_1.__metadata("design:type", String)
], NotificationLog.prototype, "relatedEntityType", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ length: 120, nullable: true }),
    tslib_1.__metadata("design:type", String)
], NotificationLog.prototype, "providerMessageId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'json', nullable: true }),
    tslib_1.__metadata("design:type", typeof (_c = typeof Record !== "undefined" && Record) === "function" ? _c : Object)
], NotificationLog.prototype, "providerResponse", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'text', nullable: true }),
    tslib_1.__metadata("design:type", String)
], NotificationLog.prototype, "errorMessage", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ default: 0 }),
    tslib_1.__metadata("design:type", Number)
], NotificationLog.prototype, "retryCount", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    tslib_1.__metadata("design:type", typeof (_d = typeof Date !== "undefined" && Date) === "function" ? _d : Object)
], NotificationLog.prototype, "scheduledAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    tslib_1.__metadata("design:type", typeof (_e = typeof Date !== "undefined" && Date) === "function" ? _e : Object)
], NotificationLog.prototype, "sentAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    tslib_1.__metadata("design:type", typeof (_f = typeof Date !== "undefined" && Date) === "function" ? _f : Object)
], NotificationLog.prototype, "deliveredAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)(),
    tslib_1.__metadata("design:type", typeof (_g = typeof Date !== "undefined" && Date) === "function" ? _g : Object)
], NotificationLog.prototype, "createdAt", void 0);
exports.NotificationLog = NotificationLog = tslib_1.__decorate([
    (0, typeorm_1.Entity)('notification_logs')
], NotificationLog);
